import {
    Grid, Card, CardContent, CardActions, CardHeader, Button, FormControl, InputLabel, Select,
    MenuItem, TextField, Paper, Typography, IconButton, Autocomplete
} from '@mui/material'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3'
import { ru } from 'date-fns/locale/ru';
import { ruRU } from '@mui/x-date-pickers/locales';
import { useForm, Controller } from 'react-hook-form'
import CreateClient from '../create_client/CreateClient';
import { useState, useEffect } from 'react'
import { api } from '../../../../api/api';
import FormError from '../../../../components/FormError/FormError';
import { useNavigate } from 'react-router-dom'
import './request_create.css'


export default function RequestCreate() {
    const navigate = useNavigate()
    const { register, trigger, control, reset, handleSubmit, setValue, formState: { errors } } = useForm({ mode: 'onSubmit' })
    const [clients, setClients] = useState([])
    const [open, setOpen] = useState(false);
    const [countries, setCountries] = useState([])
    const [cities, setCities] = useState([])
    const [valueCountry, setValueCountry] = useState()
    const [valueCity, setValueCity] = useState()
    const [clientLoading, setClientLoading] = useState(true)

    const handleSave = (form_data) => {
        api(`/api/requests/`, 'POST', form_data)
            .then((res) => {
                window.location.href = '/requests'
            })
    }

    const get_clients = async () => {
        let page = 1
        let hasMorePages = true
        let allClients = [];

        while (hasMorePages) {
            const res = await api('/api/clients/', 'GET', {}, false, {
                params: {
                    page: page
                }
            })

            if (res.status === 200) {
                allClients = [...allClients, ...res?.data.results];
                if (res?.data.total_pages === page) {
                    hasMorePages = false
                }
                else {
                    page += 1
                }
            } else {
                hasMorePages = false
            }
        }
        setClients(allClients)
        setClientLoading(false)
    }

    const get_countries_and_cities = async () => {
        await api('/api/countries/').then((res) => {
            setCountries([...JSON.parse(res.data)['countries']])
            setCities([...JSON.parse(res.data)['cities']])
        })
    }

    useEffect(() => {
        get_clients()
        get_countries_and_cities()
    }, [])


    useEffect(() => {
        const timeoutId = setTimeout(() => {
            if (valueCountry && !countries.includes(valueCountry)) {
                setCountries([...countries, valueCountry])
            }
        }, 800);
        return () => clearTimeout(timeoutId);

    }, [valueCountry]);

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            if (valueCity && !cities.includes(valueCity)) {
                setCities([...cities, valueCity])
            }
        }, 800);

        return () => clearTimeout(timeoutId);

    }, [valueCity])


    return (
        <Grid container p={0} justifyContent='center' alignItems='baseline' >
            <Card sx={{ width: '90%', marginTop: '50px' }} elevation={10}>
                <form onSubmit={handleSubmit(handleSave)} className='form_create'>
                    <CardHeader title='Создание нового запроса' align='center' sx={{ marginTop: '20px' }} />

                    <CardContent>
                        <Grid container justifyContent='center'>
                            <Grid container item md={5.5} m={1}>
                                <Grid container item xs={12} component={Paper}>
                                    <Grid item xs={12} pl={2} pt={1}>
                                        <Typography variant='body1'>Общая информация</Typography>
                                    </Grid>
                                    <Grid container item xs={12} md={6} p={1}>
                                        <Grid item xs={10}>

                                            <Autocomplete
                                                disablePortal
                                                id="combo-box-demo"
                                                fullWidth
                                                size='small'
                                                loading={clientLoading}
                                                getOptionLabel={(option) => option?.company_name}
                                                {...register('client', { required: true })}
                                                onChange={(e, v) => {
                                                    setValue('client', v?.id)
                                                    trigger('client')
                                                }}
                                                options={clients}
                                                renderInput={(params) => <TextField  {...params} label="Клиент" />}
                                            />
                                            <FormError error={errors?.client} />

                                        </Grid>
                                        <Grid item xs={2} align='end'>
                                            <IconButton aria-label="delete" size="25px" align='end'
                                                onClick={() => setOpen(true)}>
                                                <AddCircleRoundedIcon color='success' fontSize="inherit" />
                                            </IconButton>
                                        </Grid>
                                    </Grid>

                                    <Grid item xs={12} md={6} p={1}>
                                        <TextField type="text" size='small'
                                            fullWidth
                                            label="Наименование"
                                            placeholder="Наименование"
                                            {...register('name_of_cargo', {
                                                required: true,
                                            })}
                                        />
                                        <FormError error={errors?.name_of_cargo} />
                                    </Grid>

                                    <Grid item xs={12} md={6} p={1}>
                                        <TextField type="text" size='small'
                                            fullWidth
                                            label="Тип транспорта"
                                            placeholder="Тип транспорта"
                                            {...register('type_of_transport', {
                                                required: true,
                                            })}
                                        />
                                        <FormError error={errors?.type_of_transport} />
                                    </Grid>

                                    <Grid item xs={12} md={6} p={1}>
                                        <TextField type="number" size='small'
                                            fullWidth
                                            label="Цена заказчика"
                                            placeholder="Цена заказчика"
                                            {...register('customer_price', {
                                                required: true,
                                                valueAsNumber: true
                                            })}
                                        />
                                        <FormError error={errors?.customer_price} />
                                    </Grid>

                                    <Grid item xs={12} p={1}>
                                        <FormControl sx={{ width: '100%' }} size="small">
                                            <InputLabel id="demo-simple-select-label">Валюта</InputLabel>
                                            <Select

                                                className="select_field_edit_page"
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                label="Валюта"
                                                {...register('currency', { required: true })}
                                            >
                                                <MenuItem value={'USD'}>USD</MenuItem>
                                                <MenuItem value={'EUR'}>EUR</MenuItem>
                                                <MenuItem value={'BYN'}>BYN</MenuItem>
                                                <MenuItem value={'RUB'}>RUB</MenuItem>
                                            </Select>
                                        </FormControl>
                                        <FormError error={errors?.currency} />
                                    </Grid>
                                </Grid>

                                <Grid container item xs={12} mt={2} component={Paper}>
                                    <Grid item xs={12} pl={2} pt={1}>
                                        <Typography variant='body1'>Информация о грузе</Typography>
                                    </Grid>
                                    <Grid item xs={12} md={6} p={1}>
                                        <TextField type="text" size='small'
                                            fullWidth
                                            label="Вес"
                                            placeholder="Вес"
                                            {...register('weight', {
                                                required: true,
                                            })}
                                        />
                                        <FormError error={errors?.weight} />
                                    </Grid>

                                    <Grid item xs={12} md={6} p={1}>
                                        <TextField type="text" size='small'
                                            fullWidth
                                            label="Палеты"
                                            placeholder="Палеты"
                                            {...register('pallets')}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={6} p={1}>
                                        <TextField type="text" size='small'
                                            fullWidth
                                            label="Длина"
                                            placeholder="Длина"
                                            {...register('yardage')}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={6} p={1}>
                                        <TextField type="text" size='small'
                                            fullWidth
                                            label="Ширина"
                                            placeholder="Ширина"
                                            {...register('width')}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={6} p={1}>
                                        <TextField type="text" size='small'
                                            fullWidth
                                            label="Высота"
                                            placeholder="Высота"
                                            {...register('height')}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={6} p={1}>
                                        <TextField type="text" size='small'
                                            fullWidth
                                            label="Объем"
                                            placeholder="Объем"
                                            {...register('volume')}
                                        />
                                    </Grid>

                                    <Grid item xs={12} p={1}>
                                        <TextField type="text" size='small' multiline minRows='5'
                                            fullWidth
                                            label="Дополнительная информация"
                                            placeholder="Дополнительная информация"
                                            {...register('note',)}
                                        />
                                        <FormError error={errors?.note} />
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid container item xs={12} md={5.5} m={1} component={Paper} alignContent='baseline'>
                                <Grid item xs={12} pl={2} pt={1}>
                                    <Typography variant='body1'>Информация о доставке</Typography>
                                </Grid>
                                <Grid item xs={12} md={6} p={1}>
                                    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ru}>

                                        <Controller
                                            name="date_of_shipment"
                                            control={control}
                                            rules={{
                                                required: true,
                                            }}
                                            defaultValue={null}
                                            render={({ field }) => (
                                                <DatePicker
                                                    localeText={ruRU.components.MuiLocalizationProvider.defaultProps.localeText}
                                                    className='date_picker'
                                                    format="yyyy-MM-dd"
                                                    label="Дата загрузки"
                                                    value={field.value}
                                                    onChange={(value) => field.onChange(`${value.getFullYear()}-${value.getMonth() + 1}-${value.getDate()}`)}
                                                />
                                            )} />
                                    </LocalizationProvider>
                                    <FormError error={errors?.date_of_shipment} />
                                </Grid>

                                <Grid item xs={12} md={6} p={1}>
                                    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ru}>
                                        <Controller
                                            name="date_of_delivery"
                                            control={control}
                                            rules={{
                                                required: true,
                                            }}
                                            defaultValue={null}
                                            render={({ field }) => (
                                                <DatePicker
                                                    localeText={ruRU.components.MuiLocalizationProvider.defaultProps.localeText}
                                                    format="yyyy-MM-dd"
                                                    className='date_picker'
                                                    label="Дата доставки"
                                                    value={field.value}
                                                    onChange={(value) => field.onChange(`${value.getFullYear()}-${value.getMonth() + 1}-${value.getDate()}`)}
                                                />
                                            )} />
                                    </LocalizationProvider>
                                    <FormError error={errors?.date_of_delivery} />
                                </Grid>

                                <Grid item xs={12} md={6} p={1}>
                                    <Autocomplete
                                        disablePortal
                                        id="combo-box-demo"
                                        fullWidth
                                        size='small'
                                        onInput={(e) => setValueCountry(e.target.value)}
                                        getOptionLabel={(option) => option}
                                        onChange={(e, v) => {
                                            setValue('country_of_dispatch', v)
                                            trigger('country_of_dispatch')
                                        }}
                                        options={countries}
                                        renderInput={(params) => <TextField {...register('country_of_dispatch', { required: true })} {...params} label="Страна отгрузки" />}
                                    />
                                    <FormError error={errors?.country_of_dispatch} />
                                </Grid>

                                <Grid item xs={12} md={6} p={1}>
                                    <Autocomplete
                                        disablePortal
                                        id="combo-box-demo"
                                        fullWidth
                                        size='small'
                                        onInput={(e) => setValueCountry(e.target.value)}
                                        onChange={(e, v) => {
                                            setValue('delivery_country', v)
                                            trigger('delivery_country')
                                        }}
                                        getOptionLabel={(option) => option}
                                        options={countries}
                                        renderInput={(params) => <TextField {...register('delivery_country', { required: true })} {...params} label="Страна доставки" />}
                                    />
                                    <FormError error={errors?.delivery_country} />
                                </Grid>

                                <Grid item xs={12} md={6} p={1}>
                                    <Autocomplete
                                        disablePortal
                                        id="combo-box-demo"
                                        fullWidth
                                        size='small'
                                        getOptionLabel={(option) => option}
                                        onInput={(e) => setValueCity(e.target.value)}
                                        onChange={(e, v) => {
                                            setValue('city_of_dispatch', v)
                                            trigger('city_of_dispatch')
                                        }}
                                        options={cities}
                                        renderInput={(params) => <TextField {...register('city_of_dispatch', { required: true })} {...params} label="Город отгрузки" />}
                                    />
                                    <FormError error={errors?.city_of_dispatch} />
                                </Grid>

                                <Grid item xs={12} md={6} p={1}>
                                    <Autocomplete
                                        disablePortal
                                        id="combo-box-demo"
                                        fullWidth
                                        size='small'
                                        {...register('delivery_city', { required: true })}
                                        getOptionLabel={(option) => option}
                                        onInput={(e) => setValueCity(e.target.value)}
                                        onChange={(e, v) => {
                                            setValue('delivery_city', v)
                                            trigger('delivery_city')
                                        }}
                                        options={cities}
                                        renderInput={(params) => <TextField  {...params} label="Город доставки" />}
                                    />
                                    <FormError error={errors?.delivery_city} />
                                </Grid>


                                <Grid item xs={12} md={6} p={1}>
                                    <TextField type="text" size='small'
                                        fullWidth
                                        label="Адрес отгрузки"
                                        placeholder="Адрес отгрузки"
                                        {...register('address_of_dispatch')}
                                    />
                                </Grid>

                                <Grid item xs={12} md={6} p={1}>
                                    <TextField type="text" size='small'
                                        fullWidth
                                        label="Адрес доставки"
                                        placeholder="Адрес доставки"
                                        {...register('delivery_address')}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </CardContent>

                    <CardActions align='center' className='card_action'>
                        <Grid container p={1} justifyContent='flex-end'>
                            <Grid item align='end' p={1}>
                                <Button variant='outlined' color='secondary' onClick={() => navigate('/')}>Закрыть</Button>
                            </Grid>
                            <Grid item align='end' p={1}>
                                <Button variant='outlined' onClick={() => reset()} color='error'>Очистить</Button>
                            </Grid>

                            <Grid item align='start' p={1}>
                                <Button variant='outlined' color='success' type='submit'>Создать</Button>
                            </Grid>
                        </Grid>
                    </CardActions>
                </form>
                <CreateClient setOpen={setOpen} open={open} setClients={setClients} setClientLoading={setClientLoading}/>
            </Card>
        </Grid>
    )
}